<template>
    <div id="home">
        <div class="header">
            <!-- <img src="../../assets/img/index/bg_yunduan_home.png" alt class="bg" /> -->
            <div class="top dl_center">
                <div v-if="active == 1" class="hd-left-top">
                    <div class="hd-left-top-wallets" @click="showAllWallets()">
                        <img :src="walletPng" alt class="wallet-img" />

                    </div>


                </div>


                <!-- <img
          src="../../assets/img/index/home_ico_fenxianghaoyou.png"
          alt
          class="file dl_margin3_top wx_lf"
          @click="InviteFriends()"
        /> -->
                <!-- <h1 class="page-title">{{ $t("home.welcome") }}</h1> -->
                <h1 class="page-title">{{ $t("nologin.cloud_wallet") }}</h1>
                <!-- <ul class="title dl_margin2_top">
          <li
            v-for="(item, index) in list"
            @click="toggle(index)"
            :class="{ is_active: index == active }"
            :key="index"
          >
            {{ item }}
          </li>
        </ul> -->
                <div class="cata-wx-wrapper">
                    <div class="scanner" v-if="active == 1 && !isFirstWallet" @click="isQrScanner = true">
                        <img src="../../assets/img/ico_saoyisao_tanjkuang.png" alt class="scanner-mark" />

                    </div>

                    <img src="../../assets/img/index/home_ico_gengduo.png" alt class="cata wx_rt" @click="share()" />


                </div>

            </div>
            <div class="bottom">
                <div class="bottom-left" v-if="!isLogin && active == 0">

                    <p class="page-slogan">{{ $t("nologin.welcomeTo") }}</p>
                </div>
                <div class="bottom-left" v-else-if="isLogin && active == 0">
                    <p class="asset wx_fontSize1">{{ $t("home.total") }}</p>
                    <p class="amount wx_fontSize5">
                        {{ currency_char }}{{ limitedColudAllAmount }}
                    </p>
                </div>
                <div class="bottom-left" v-else-if="active == 1">
                    <p class="asset wx_fontSize1">{{ $t("home.total") }}</p>
                    <p class="amount wx_fontSize5">
                        {{ currency_char }}{{ limitedHdAllAmount }}
                    </p>
                </div>
                <img src="../../assets/img/index/home_ico_tianjia.png" alt class="add" @click="search()"
                    ref="searched" />
                <ul class="title" @click="toggleWhenLogin()" :class="['item' + active]">
                    <li v-for="(item, index) in list" :class="[
                        active == index && active == 0 ? 'active_li0' : 'active_li',
                        active == index && active == 1 ? 'active_li1' : 'active_li',
                    ]" :key="index">
                        <img :src="item" alt="" class="" srcset="" />
                    </li>
                </ul>
            </div>
            <!--
      <div class="message"  ref="message">
        <p class="Mes_title wx_fontSize2">

          {{noticeList.post_title}}
        </p>
        <a :href="noticeList.visit_url"><p class="Mes_main ">{{noticeList.post_excerpt}}</p></a>

      </div>
      -->
            <!-- <div class="intro" ref="intro" v-show="isLogin && active == 0">
        <div class="intro_title">
          <h4>{{ $t("ads.title") }}</h4>
        </div>
        <div class="intro_desc">
          {{ $t("ads.content") }}
          <span
            style="
              position: relative;
              top: 15px;
              right: -20px;
              text-decoration: underline;
            "
            @click="plandetail(5)"
            @click.stop="doSomething($event)"
            >{{ $t("ads.buy") }}</span
          >
        </div>
      </div> -->
        </div>
        <HdWallet v-if="this.active == 1" :showWallets="showWallets" @IsWalletShows="isWalletShow"></HdWallet>
        <!-- about cloud wallet intro -->
        <!-- <div class="content" style="display: block" v-show="!isLogin && active == 0">
            <div class="main1">
                <div class="main1-content">
                    <div class="main1-content-left">
                        <p class="wx_fontSize4 title_wallet">
                            {{ $t("nologin.cloud_wallet") }}
                        </p>
                         <div class="top_main">
                            <span class="wx_fontSize2">{{ $t("nologin.cloud1") }}</span>
                        </div>
                        <div class="top_main">
                            <span class="wx_fontSize2">{{ $t("nologin.cloud2") }}</span>
                        </div>
                        <div class="top_main">
                            <span class="wx_fontSize2">{{ $t("nologin.cloud3") }}</span>
                        </div> 
                    </div>

                </div>
            </div>
        </div> -->

        <div class="button-noLogin" v-if="!isLogin && active == 0">

            <!-- <div class="resgiter vx_lf" @click="login()">
                <div class="zhuce-btn bg-blue">{{ $t("login.submit") }}</div>

            </div> -->

            <!-- <div class="resgiter wx_lf" @click="register()">
                <div class="zhuce-btn bg-blue2">{{ $t("nologin.button1") }}</div>
            </div> -->
            <!-- <div class="login wx_rt" @click="login()">
              <div class="zhuce-btn bg-blue">{{ $t("nologin.button2") }}</div>
            </div> -->
            <div class="login login-2u wx_rt" @click="loginWithUU()">
                <div class="zhuce-btn">{{ $t("nologin.button_oauth") }}</div>
            </div>
        </div>
        <!-- about 2ut activity @click="plandetail(5)"-->
        <!-- <div class="intro" ref="intro"
            v-show="isLogin && active == 0 && $store.state.userInfo.auth_id < 2 && !$store.state.userInfo.discount">
            <div class="intro-content">
                <div class="intro-content-left">
                    <div class="intro_title">
                        <h4>{{ $t("ads.title") }}</h4>
                    </div>
                    <div class="intro_desc">{{ $t("ads.content") }}</div>

                </div>
            </div>
        </div> -->
        <div style="height: 10px;"></div>
        <!-- +86用户屏蔽
        <div v-if="$store.getters.userInfo.areacode != '86'">
            <div v-if="isLogin && active == 0" @click="$router.push({ path: '/index/premmt', query: {tab: 2} })">
                <img src="../../assets/img/ad-1.png" style="width: 100%;display: block;" />
            </div>
        </div>
         -->
        <div style="height: 10px;"></div>
		<div class="intro2" ref="intro"
		    v-if="isLogin && active == 0">
            <div class="intro-label2">
            </div>
            <div class="intro-content2">
                <div class="intro-content-left2">
                    <div class="intro_title2">
                        <h4>{{ $t("ads.tip") }}</h4>
                    </div>

                </div>
                <div class="intro-buy-now2" @click="handleBuy9()">
                    {{ $t("ads.buy") }}

                </div>
            </div>
        </div>
        
		<div style="height: 10px;"></div>
		<div @click="$router.push({ path: '/index/package', query: {tab: 2} })">
			<div class="intro intro2" v-if="isLogin">
				<div class="intro-content">
					<div class="intro-content-left" style="position: relative;">
						<div class="greenx">
							GO
						</div>
						<div class="intro_title">
							<h4>{{ $t("ads.title") }}</h4>
						</div>
						<div class="intro_desc">{{ $t("ads.content2") }}</div>
					</div>
				</div>
			</div>
		</div>
		<div style="height: 10px;"></div>
       <!--
		<a :href="greenxUrl" target="_blank">
			<div class="intro intro2" style="background: #ffffff;background-image: none !important;height: 80px;" v-if="isLogin">
				<div class="intro-content">
					<div class="intro-content-left" style="position: relative;">
						<div class="greenx2">
							GO
						</div>
						<div class="intro_title" style="height: auto;">
							<img src="../../assets/img/greenx.png" style="height: 64px;display: block;" />
						</div>
					</div>
				</div>
			</div>
		</a>
        -->
        <!-- about cloud wallet -->
        <div class="content" style="display: block" v-show="isLogin && active == 0 && CloudList.length > 0">
            <mt-loadmore :topPullText="$t('system.topPullText')" :topDropText="$t('system.topDropText')"
                :topLoadingText="$t('system.topLoadingText')" :top-method="loadTop" :bottom-all-loaded="allLoaded"
                :autoFill="autoFill" ref="loadmore">
                <ul class="content_detail">
                    <li v-for="(item, index) in CloudList" @click="
                        CoinPurse(
                            item.id,
                            item.coin_symbol,
                            item.cloud_balance,
                            item.img_url,
                            item.introduce,
                            '云端'
                        )
                    " :key="index">
                        <img v-bind:src="item.img_url" alt class="oImg" />
                        <span class="currency_name">{{ item.coin_symbol }}</span>
                        <!--
                        <span class="buy_sto" v-if="item.coin_symbol == '2UT'" @click.stop="plandetail(5)">{{
                                $t("ads.buy")
                        }}</span>
                        -->
                        <span class="buy_sto" v-if="item.coin_symbol == 'A2U'" @click.stop="buyau()">{{ $t("ads.buy")
                        }}</span>

                        <div class="amount_of wx_rt" v-if="item.coin_symbol != '2UPoint'" style="text-align: right;">
                            <p class="count wx_fontSize2">
								{{ item.cloud_balance }}
								<span v-if="item.locked > 0" style="color: #999;"> + {{item.locked}}</span>
							</p>
                            <!-- <p class="money wx_fontSize2">
                                {{ item.currency_symbol }}{{ item.price }}
                            </p> -->
                        </div>
                        <div class="amount_of wx_rt" v-if="item.coin_symbol == '2UPoint'">
                            <p class="count wx_fontSize2">U2U {{ item.cloud_balance }}</p>
                            <p class="money wx_fontSize2">2UT {{ item.cloud_balance }}</p>
                        </div>
                    </li>
                </ul>
            </mt-loadmore>
        </div>

        <!-- hd wallet nologin -->
        <!--<div class="content" v-show="!isLogin && active == 1">
            <div class="main1">
                <div class="main1-content">
                    <div class="main1-content-left">
                        <p class="wx_fontSize4 title_wallet">
                            {{ $t("nologin.hd_wallet") }}
                        </p>
                        <div class="top_main">
                            <span class="wx_fontSize2">{{ $t("nologin.hd1") }}</span>
                        </div>
                        <div class="top_main">
                            <span class="wx_fontSize2">{{ $t("nologin.hd2") }}</span>
                        </div>
                        <div class="top_main">
                            <span class="wx_fontSize2">{{ $t("nologin.hd3") }}</span>
                        </div>
                    </div>
                    <div class="button-noLogin">
                        <div class="resgiter wx_lf" @click="register()">
                            <div class="zhuce-btn bg-blue2">{{ $t("nologin.button3") }}</div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>-->

        <!-- hd wallet login  -->
        <!--<div class="content local" v-show="isLogin && active == 1 && LocalList.length > 0">
            <mt-loadmore :topPullText="$t('system.topPullText')" :topDropText="$t('system.topDropText')"
                :topLoadingText="$t('system.topLoadingText')" :top-method="loadTopLocal" :bottom-all-loaded="allLoaded"
                :autoFill="autoFill" ref="loadmoreLocal">
                <ul class="content_detail" ref="contentDetail">
                    <li v-for="(item, index) in LocalList" @click="
                        CoinPurse(
                            item.id,
                            item.coin_symbol,
                            item.chain_balance,
                            item.img_url,
                            'HD'
                        )
                    " :key="index">
                        <img v-bind:src="item.img_url" alt class="oImg" />
                        <span class="currency_name">{{ item.coin_symbol }}</span>
                        <div class="amount_of wx_rt">
                            <p class="count wx_fontSize3">{{ item.chain_balance }}</p>
                            <p class="money wx_fontSize2">
                                {{ item.currency_symbol }}{{ item.price }}
                            </p>
                        </div>
                    </li>
                </ul>
            </mt-loadmore>
        </div>-->

        <!-- local wallet islogin and localList = 0  -->
        <!--<div class="content deneme" v-show="isLogin && active == 1 && LocalList.length == 0">-->
        <!--<div class="main_hd">-->
        <!--<p class="wx_fontSize4 title_wallet">{{ $t("nologin.hd_wallet") }}</p>-->
        <!--<div class="top_main">-->
        <!-- <img src="@/assets/img/login_ico_siyao_bendi.png" alt /> -->
        <!--<span class="wx_fontSize2">{{ $t("nologin.hd1") }}</span>
                </div>-->
        <!--<div class="top_main">-->
        <!-- <img src="@/assets/img/login_ico_daoru_bendi.png" alt /> -->
        <!--<span class="wx_fontSize2">{{ $t("nologin.hd2") }}</span>-->
        <!--</div>-->
        <!--<div class="top_main">-->
        <!-- <img src="@/assets/img/login_ico_daibi_bendi.png" alt /> -->
        <!--<span class="wx_fontSize2">{{ $t("nologin.hd3") }}</span>
                </div>
            </div>
            <div class="button create-import-btn">
                <div class="create-btn" @click="createPay()">
                    <div class="zhuce-btn bg-blue">{{ $t("home.create_wallet") }}</div>
                </div>
                <div class="import-btn wx_rt" @click="goPin('钱包')">
                    <div class="zhuce-btn bg-blue">{{ $t("home.import_wallet") }}</div>
                </div>
            </div>
        </div>-->
        <div class="triangle" v-show="show">
            <div class="triangle_border_up">
                <span></span>
            </div>
        </div>
        <ul class="share" v-show="show" ref="cloud">
            <li @click="InviteFriends()" style="display: none">
                <img src="../../assets/img/ico_yaoqing_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.invite") }}</span>
            </li>
            <li @click="sendEnvelope()" style="display: none">
                <img src="../../assets/img/ico_hongbao_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.redbag") }}</span>
            </li>
            <li @click="against()">
                <img src="../../assets/img/ico_shandui_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.exchange") }}</span>
            </li>
            <li @click="Flicking()">
                <img src="../../assets/img/ico_saoyisao_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.scan") }}</span>
            </li>
            <li @click="addressBook($t('coin.address_book1'))">
                <img src="../../assets/img/ico_dizhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.address_book") }}</span>
            </li>
            <li @click="historyNotice($t('coin.notices2'))">
                <img src="../../assets/img/ico_tongzhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.notice") }}</span>
            </li>
            <li style="border: 0" @click="setUp()">
                <img src="../../assets/img/ico_shezhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.setting") }}</span>
            </li>
        </ul>
        <div class="triangle" v-show="isShow">
            <div class="triangle_border_up">
                <span></span>
            </div>
        </div>
        <ul class="share" v-show="isShow" ref="HD">
            <li @click="goPin('助记词')">
                <img src="../../assets/img/ico_chakani_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize2">{{
                is_backup ? $t("home.view_mnemonic") : $t("home.backup_mnemonic")
                }}</span>
            </li>
            <li @click="goPin('钱包')">
                <img src="../../assets/img/ico_daoruqianbao_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.import_wallet") }}</span>
            </li>
            <li @click="addressBook($t('coin.address_book2'))">
                <img src="../../assets/img/ico_dizhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.address_book") }}</span>
            </li>
            <li @click="historyNotice($t('coin.notices'))">
                <img src="../../assets/img/ico_tongzhi_tanjkuang.png" alt class="mark" />
                <span class="wx_fontSize3">{{ $t("home.notice") }}</span>
            </li>
        </ul>
		<div v-if="isGGSHow" class="popup-gg">
			<div class="gg">
				<div class="gg-title">重要通知</div>
				<div class="gg-line">尊敬的用户, 大家好：</div>
				<div class="gg-line">1、因Apps应用商店上架的要求，2U Chat聊天平台暂时不接入Auwallet 和TimeEX的链接。</div>
				<div class="gg-line">2、用户可以通过https://mobile.auwallet.io 进入钱包和https://mobile.timeex.io进入交易所。</div>
				<div class="gg-line">3、2UT是在Green X上市的以STO（Security Token Offering）形式的数字股票，不是ICO。</div>
				<div class="gg-line">4、如用户已经购买了2UT但仍认为还不清楚了解STO可能带来的风险。那么可以按购买时原价申请退还。</div>
				<div class="gg-line">5、但请您在不了解STO的前提下，请不要做出有损于2UT信誉的言行。    </div>
				<div style="text-align: right;padding-top: 48px;">
					AUWallet && TimeEx<br />
					2023年12月23日
				</div>
				<div class="close" @click="isGGSHow = false">
					知道了
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import { Toast } from "mint-ui";
import {
    saoYiSaoMessage,
    createUniqueString,
    parseTime,
    getAppValue,
} from "@/utils/index";
import imageHdwallet from "@/assets/img/hdWallet.png";
import imageCloudwallet from "@/assets/img/cloudWallet.png";
import { validateEmpty } from "@/utils/validate";
import { httpCloudLists, httpNoticeLists } from "@/api/index";
import { httpList, httpCreate, httpInit } from "@/api/hdwallet";
import { numFilter } from "@/filters/index";
import HdWallet from './hdWallet/Index.vue'
import { httpDoOauth } from "@/api/login";
import { loginIn } from "@/utils/index";
import store from '@/store'
export default {
    data: function () {
        return {
            list: [imageHdwallet, imageCloudwallet],
            walletPng: require("@/assets/img/tab_icon_wallets.png"),
			isGGSHow: false,
            isLogin: false,
            active: 0,
            show: false,
            isShow: false,
            is_backup: false,
            jumpAddrs: "",
            getValue: "",
            CloudList: [],
            currentView: "",
            allLoaded: false,
            autoFill: false,
            LocalList: [],
            noticeList: {},
            currency: "",
            currency_char: "",
            currency_usd_rate: "",
            coludAllAmount: 0,
            limitedColudAllAmount: 0,
            HdAllAmount: 0,
            limitedHdAllAmount: 0,
            showWallets: false,
            isFirstWallet: false,
			token: '',
			greenxUrl: 'https://oauth.2uap.com/login?service=greenx&device=web&redirecturi=https://card.green-x.io/greenx-sync/api/2uchat/oauth'
        };
    },
    created() { },
    mounted: function () {
        // this.noticeLists();
		this.token = this.$store.getters.token;
		
    },
    activated() {
		let that = this
        this.token = this.$store.getters.token;
		console.log('token home=',this.token)
		console.log('token home=',this.$store.getters.userInfo.areacode)
		if(this.token == ''){
			this.isLogin = false
			this.active = 0
		}
        // if (validateEmpty(this.token)) {
        //   this.$router.replace("/index/nologin");
        //   return;
        // }
		
        this.isFirstWallet = validateEmpty(window.LS.get("mnemonic"))
        const params = new URLSearchParams(location.search);
		console.log('params',params.get("lang"))
		if (params.get("lang")) {
			let lang = params.get("lang")
			let slang = 'en'
			if(lang == 'zh-cn'){
				slang = 'zh'
			}
			this.$store.dispatch("setLanguage", slang);
			this.$i18n.locale = slang;
			localStorage.setItem("locale", slang);
		}
        if (params.has("access_token")) {
            this.token = params.get("access_token");
            this.doOauth();
            params.delete("access_token");
            window.history.replaceState({}, '', `${location.pathname}`);
        } else {
            this.initActivated();
        }
		// store.dispatch('setInitInfo', res.data)
		
		console.log('this.$store.getters====',this.$store.getters.userInfo.areacode)
		//this.greenxUrl = 'https://app.auwallet.io/api/home/index/go?tk=' + this.token
		if(this.$store.getters.userInfo.areacode === '86'){
		let ggcount = localStorage.getItem('ggcount')
			if(!ggcount){
				localStorage.setItem('ggcount', 0)
				this.isGGSHow = true
			}else{
				ggcount = parseInt(ggcount)
				if(ggcount <= 3){
					localStorage.setItem('ggcount', (ggcount + 1))
					this.isGGSHow = true
				}else{
					this.isGGSHow = false
				}
			}
		}

		// 跳转去预售页面的连接背后的系统已经初步完成了，可供测试了。请使用以下链接。
		// https://green-x-proxy.netlify.app/timeex/pre-sale?externalId={2u chat id)&groupId={any id}。
		// 用户邮件地址可选提供，如果没提供，我们会采用Green-x内部的邮件地址。
		// 提供的方式是在连接后部添加&email={any email}
        // this.$refs.message.style.display = 'none';
    },
    methods: {
		handleBuy9(){
			// && this.$store.state.userInfo.auth_id >= 2 && this.$store.state.userInfo.discount
			console.log('buy 9 sale')
			if(this.$store.state.userInfo.auth_id >= 2 && this.$store.state.userInfo.discount){
				this.$router.push({ path: '/discount-buy', query: { coin: 'U2U' } })
			}else{
				console.log('no auth_id == 2')
				Toast(this.$t("home.cant9sale"))
			}
		},
        initActivated() {
            //console.log("----111-----");
            this.show = false;
            this.isShow = false;
            if (this.$route.query.result) {
                if (this.jumpAddrs == "助记词") {
                    if (!this.is_backup) {
                        this.$router.push("/backup");
                    }
                    else {
                        this.$router.push("/lookWords");
                    }
                }
                else if (this.jumpAddrs == "钱包") {
                    this.$router.push("/selectWords");
                }
            }
            this.currency_char = this.$store.state.currency_char;
            this.currency_usd_rate = this.$store.state.currency_usd_rate;
            // if (this.active == 1 && this.LocalList.length == 0) {
            //   if (validateEmpty(this.$store.state.hdtoken)) {
            //     this.$refs.contented.style.display = 'block'
            //     this.$refs.contentDetail.style.display = 'none'
            //     this.$refs.searched.style.display = 'none'
            //   }else{
            //     this.$refs.contented.style.display = 'none'
            //     this.$refs.contentDetail.style.display = 'block'
            //     this.$refs.searched.style.display = 'block'
            //     this.getLocalData()
            //   }
            // }else
            if (this.active == 1) {
                this.$refs.intro.style.display = 'none';
            }
            if (this.active == 0) {
                // this.$refs.intro.style.display = 'block';
                //   this.$refs.contented.style.display = 'none'
                //   this.$refs.contentDetail.style.display = 'block';
                //   this.$refs.searched.style.display = 'block'
                if(this.token != ''){
					this.getData();
				}
				
                //   this.$refs.intro.style.display = 'block';
            }
            window.getvalueFromApp = this.getvalueFromApp;
        },
        buyau() {
            this.$router.push({
                path: "/buyAU",
            });
        },
        loadTop() {
            this.getData();
        },
        loadTopLocal() {
            //this.getLocalData();
            return
        },
        getData: function () {
            httpCloudLists({ currency: this.$store.getters.currency })
                .then((res) => {
                    this.CloudList = [];
                    this.coludAllAmount = 0;
                    // console.log('sadas');
                    if (res.data.list) {
                        //this.CloudList = res.data.list;
                        console.log('this.CloudList',this.CloudList);
						res.data.list.forEach((item,index)=>{
							// console.log(item)
							if(item.coin_symbol != 'BTC' && item.coin_symbol != 'ETH'){
								this.CloudList.push(item)
							}
						})
                    }
                    // console.log(res);
                    // for (var i = 0; i < this.CloudList.length; i++) {
                    //     this.coludAllAmount += Number(res.data.list[i].price);
                    //     // this.CloudList[i].img_url = window.getLocalCoinImg(this.CloudList[i].coin_symbol);
                    // }
                    // this.$refs.loadmore.onTopLoaded();
                    // this.limitedColudAllAmount = Number((Math.floor(this.coludAllAmount * 10000) / 10000).toFixed(4));
                    // if (this.limitedColudAllAmount == 0) {
                    //     this.limitedColudAllAmount = 0;
                    // }
					this.limitedColudAllAmount = res.data.total_price
                })
                .catch(() => {
                    this.$refs.loadmore.onTopLoaded();
                });
        },
        getLocalData: function () {
            httpList({ currency: this.$store.getters.currency })
                .then((res) => {
                    this.LocalList = [];
                    this.HdAllAmount = 0;
                    // console.log(this.HdAllAmount);
                    // console.log(res);
                    this.LocalList = res.data.list;
                    for (var i = 0; i < this.LocalList.length; i++) {
                        this.HdAllAmount += Number(res.data.list[i].price * 1);
                        this.LocalList[i].img_url = window.getLocalCoinImg(this.LocalList[i].coin_symbol);
                    }
                    this.limitedHdAllAmount = Number((Math.floor(this.HdAllAmount * 10000) / 10000).toFixed(4));
                    debugger;
                    if (this.limitedHdAllAmount == 0) {
                        this.limitedHdAllAmount = 0;
                    }
                    this.$refs.loadmoreLocal.onTopLoaded();
                })
                .catch(() => {
                    this.$refs.loadmoreLocal.onTopLoaded();
                });
        },
        toggle(index) {
            //  this.active = index;
            // var tabCardCollection = document.querySelectorAll(".content"),
            //   len = tabCardCollection.length;
            // for (var i = 0; i < len; i++) {
            //   tabCardCollection[i].style.display = "none";
            // }
            // tabCardCollection[index].style.display = "block";
            // if (index == 0) {
            //   document.querySelector(".file").style.display = "block";
            //   // document.querySelector(".message").style.display = "block";
            //   this.isShow = false;
            // } else if (index == 1) {
            //   document.querySelector(".file").style.display = "none";
            //   // document.querySelector(".message").style.display = "none";
            //   this.show = false;
            // }
            // if (index == 1 && this.LocalList.length == 0) {
            //   if (validateEmpty(this.$store.state.hdtoken)) {
            //     this.$refs.contented.style.display = "block";
            //     this.$refs.contentDetail.style.display = "none";
            //     this.$refs.searched.style.display = "none";
            //   } else {
            //     this.$refs.contented.style.display = "none";
            //     this.$refs.contentDetail.style.display = "block";
            //     this.$refs.searched.style.display = "block";
            //     this.getLocalData();
            //   }
            // } else {
            //   this.$refs.contented.style.display = "none";
            //   this.$refs.contentDetail.style.display = "block";
            //   this.$refs.searched.style.display = "block";
            //   this.$refs.intro.style.display = "block";
            // }
            // if (index == 1) {
            //   this.$refs.intro.style.display = "none";
            // }
            // this.$refs.message.style.display = 'none';
        },
        toggleWhenLogin() {
            if (this.active == 1) {
                this.active = 0;
            }
            else if (this.active == 0) {
                this.active = 1;
            }
			console.log('homeActive', this.active)
			// localStorage.setItem('homeActive', this.active)
			this.$store.dispatch("setHomeActive", this.active);
            // console.log(this.active);
            // this.walletHDLocalData.hdMoreShow = false;
            // this.walletCloudData.cloudMoreshow = false;
            // this.dealWalletData();
        },
        hidden() {
            this.isShow = false;
            this.show = false;
        },
        share() {
            if (this.active == 0) {
                this.show = !this.show;
            }
            else if (this.active == 1) {
                this.isShow = !this.isShow;
            }
        },
        CoinPurse(id, title, price, img_url, coinInfo, category) {
            this.$router.push({
                path: "/CoinPurse",
                query: {
                    id: id,
                    title: title,
                    price: price,
                    img_url: img_url,
                    coinInfo: coinInfo,
                    category: category,
                },
            });
        },
        InviteFriends() {
            this.$router.push("/share");
        },
        sendEnvelope() {
            this.$router.push("/sendEnvelope");
        },
        against() {
            this.$router.push("/against");
        },
        addressBook(title) {
            this.$router.push({ path: "/addressBook", query: { title: title } });
        },
        historyNotice(title) {
            this.$router.push({ path: "/historyNotice", query: { title: title } });
        },
        setUp() {
            this.$router.push("/setUp");
        },
        search() {
            if (this.active == 0) {
                this.$router.push("/search");
            }
            else {
                this.$router.push("/hDsearch");
            }
        },
        createPay() {
            this.$router.push("/mnemonicWord");
        },
        goPin: function (name) {
            this.jumpAddrs = name;
            // validateEmpty(this.$store.getters.Token)
            // if (!validateEmpty(this.$store.getters.pin)) {
            //   this.$router.push("/pincheck");
            // } else {
            if (this.jumpAddrs == "助记词") {
                if (!this.is_backup) {
                    this.$router.push("/backup");
                }
                else {
                    this.$router.push("/lookWords");
                }
            }
            else if (this.jumpAddrs == "钱包") {
                this.$router.push("/selectWords");
            }
            //}
        },
        Flicking() {
            saoYiSaoMessage();
        },
        getvalueFromApp(value) {
            this.getValue = value;
            let t = value.split(":");
            if (t.length != 2) {
                Toast(value);
            }
            else {
                this.$router.push({
                    path: "/send",
                    query: { coin_symbol: t[0], category: "云端", addr: t[1] },
                });
            }
        },
        noticeLists: function () {
            httpNoticeLists({ type: 1 })
                .then((res) => {
                    this.noticeList = res.data.list[0];
                })
                .catch(() => { });
        },
        plandetail(id) {
            this.$router.push({
                path: "/plandetail",
                query: { title: this.$t("ads.plan_name"), id: id },
            });
        },
        register() {
            this.$router.push("/register");
        },
        login() {
            this.$router.push("/");
        },
        loginWithUU() {
            var service_name = "auwallet"; //should be changed to auwallet after wallet backend's update
            // var service_name = "testauwallet"; //should be changed to auwallet after wallet backend's update
            var device_name = "web";
            window.location.href =
                "https://oauth.2uap.com/login?service=" +
                service_name +
                "&device=" +
                device_name +
                "&redirecturi=" +
                window.location.href;
        },

        showAllWallets() {
            this.showWallets = !this.showWallets
        },

        isWalletShow(value) {
            this.showWallets = value
        },
        doOauth() {
            if (this.isLogin) {
                return;
            }
            var data = {
                access_token: this.token,
            };

            httpDoOauth(data).then((res) => {
                //Toast(res.msg);
                if (res.data.success == "true") {
                    this.res = res;
                    // console.log(res.data.user);
					//this.greenxUrl = 'https://app.auwallet.io/api/home/index/go?tk=' + res.data.token
                    this.$store.dispatch("setToken", res.data.token);
                    this.$store.dispatch("setUserInfo", res.data.user);
                    //this.$router.replace("/index/home");
                    // console.log(JSON.stringify(res.data.user));

                    this.initActivated();
                }

                loginIn(res.data.token);
            })
                .catch(() => { });
        },
    },
    watch: {
        "$store.state.userInfo": {
            //this.userInfo = val;
            immediate: true,
            handler(val, oldVal) {
                if (val.constructor === Object) {
                    // console.log("------" + val.discount);
                    this.isLogin = Object.keys(val).length != 0 ? true : false;

                } else {
                    this.isLogin = false
                }
                // console.log(val, 'myvalva');

            }
        },

    },
    computed: {
        isQrScanner: {
            get() {
                return this.$store.state.isQrScanner
            },
            set(value) {
                this.$store.dispatch('setIsQrScanner', value)
            }
        },


    },
    components: { HdWallet }
}
</script>
<style scoped>
* {
    box-sizing: border-box;
}
.popup-gg{
	position: fixed;
	width: 100%;
	height: 100vh;
	z-index: 99999999999;
	background: rgba(0,0,0,0.1);
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
.gg{
	width: calc(100% - 64px);
	height: calc(100% - 64px);
	background: #ffffff;
	border-radius: 18px;
	padding: 24px;
	position: relative;
}
.gg-title{
	text-align: center;
	padding: 24px 0;
	font-size: 18px;
	font-weight: bold;
}
.gg-line{
	padding: 8px 0;
}
.close{
	position: absolute;
	width: 40%;
	bottom:48px;
	left: 30%;
	text-align: center;
	background-color: #0078ff;
	color: #ffffff;
	border-radius: 24px;
	padding: 12px 0;
}
#home {
    width: 100%;
    background: #f6f8fa;
    height: 100%;
    padding-bottom: 100px;


}

#index {
    height: 100%;
}

.mint-loadmore {
    overflow: hidden !important;
}

/*顶部*/
.header {
    width: 100%;
}

.header .bg {
    width: 100%;
    height: 100%;
}

.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 0 !important;
    height: 60px;
}

.page-title {
    font-size: 1.875rem;
}

.bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 10px 30px;
}

.bottom-left {
    width: 80%;
    padding: 20px 0;
}

.file {
    width: 20px;
    height: 20px;
    margin-left: 15px;
}

.cata {
    width: 25px;
    height: 7px;
}

.title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #0078ff;
    width: 74px;
    height: 40px;
    border-radius: 20px;
    padding: 2px 3px;
    transition: all 0.5 ease-in-out;
}

.title.item0 {
    background-color: #0191f5;
    transition: all 0.5s ease-in-out;
}

.title.item1 {
    background-color: #00c900;
    transition: all 0.5s ease-in-out;
}

.title li {
    transition: all 0.5s ease-in-out;
}

.title li img {
    width: 34px;
    height: 34px;
    margin-top: 4px;
}

/* .title .is_active {
  opacity: 0;
} */
.title .active_li {
    opacity: 1;
    transform: translateX(0);
}

.title .active_li0 {
    opacity: 0;
    transform: translateX(20px);
}

.title .active_li1 {
    opacity: 0;
    transform: translateX(-20px);
}

#index .asset {
    color: #828590;
    margin-top: -10px;
}

#index .amount {
    color: #12172e;
}

#index .add {
    width: 34px;
    height: 34px;
    background-color: #a9afbd;
    border-radius: 50%;
    margin-right: 10px;
}

.message {
    background-color: #fff;
    position: absolute;
    top: 160px;
    width: calc(100% - 20px);
    overflow: hidden;
    z-index: 1;
    margin: 5px 5px 5px 10px;
    border-radius: 10px;
    height: 100px;
    box-shadow: 2px 2px 2px #dcdcdc;
    background-image: url("../../assets/img/index/bg_intro.png");
}

.Mes_title {
    width: 100%;
    height: 35px;
    line-height: 40px;
    color: #8c92a8;
    position: relative;
    margin-left: 12px;
    font-weight: 600;
}

.Mes_title img {
    position: absolute;
    left: -23px;
    top: 15px;
    width: 15px;
    height: 13px;
}

.Mes_main {
    color: #212529;
    padding: 0 12px;
    line-height: 18.5px;
    font-size: 0.875rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: 600;
}

.titme {
    width: 100%;
    padding: 0 12px;
    height: 40px;
    position: relative;
    line-height: 40px;
    color: #8c92a8;
}

.titme .detail {
    position: absolute;
    right: 30px;
}

.titme .detail a {
    color: #0191f5;
}

/*内容*/

.content {
    width: 100%;
    padding: 0 10px;
    z-index: 1000;
}

.main1 {
    width: 100%;
    margin-top: 25px;
    box-shadow: 0 20px 15px 8px #dae5f0;
    background: #fff;
    padding-bottom: 20px;
    padding: 30px 20px;
    border-radius: 10px;
    text-align: left;
}

.main1-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.top_main img {
    width: 20px;
    height: 20px;
}

.top_main span {
    color: #828590;
    position: relative;
    top: -5px;
    text-align: left;
}

.btn-login {
    color: #12172e;
    font-size: 1.375rem;
    font-weight: 600;
}

.page-slogan {
    color: #828590;
    font-size: 1rem;
    font-weight: 400;
}

/* .content {
  background: #f6f6f6;
  width: 100%;
  padding-top: 65px;
  display: none;
  height: calc(100% - 170px);
  overflow: scroll;
  box-sizing: border-box;
  width: calc(100% - 10px);
} */
.local {
    padding-top: 0;
}

.content_detail {
    margin-right: 0px;
}

.content_detail li {
    background: #fff;
    margin: 10px 0px 5px 10px;
    border-radius: 5px;
    border: 1px solid #eae8e8;
    box-shadow: 0px 1px 1px #eae8e8;
}

.oImg {
    width: 48px;
    height: 48px;
    margin: 15px 14px 12px 14px;
}

.currency_name {
    position: relative;
    top: -30px;
}

.amount_of {
    height: 100%;
    text-align: center;
    margin-right: 10px;
}

.count {
    color: #212529;
    padding: 15px 0 10px 0;
    font-weight: bold;
    text-align: right;
}

.money {
    color: #8c92a8;
}

/*分享*/
.share {
    width: 250px;
    position: absolute;
    background: #fff;
    top: 68px;
    right: 15px;
    border-radius: 6px;
    box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
    overflow: hidden;
    z-index: 2;
}

.share li {
    margin: 0 15px;
    padding: 15px 0;
    border-bottom: 1px solid #e3e8ed;
}

.mark {
    width: 20px;
    height: 20px;
    margin: 0 16px 0 5px;
    position: relative;
    top: 4px;
}

.main {
    color: #212529;
    position: relative;
}

.triangle {
    position: absolute;
    top: 60px;
    right: 40px;
    z-index: 100;
}

.triangle_border_up {
    width: 0;
    height: 0;
    border-width: 0 8px 8px;
    border-style: solid;
    border-color: transparent transparent #fff;
    /*透明 透明  灰*/
    position: relative;
}

/*HD内容*/
.contented {
    background: #f6f8fa;
    padding: 0;
}

.create-import-btn {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.create-btn,
.import-btn {
    width: 47%;
    height: 40px;
}

.main_hd {
    width: 100%;
    margin-top: 30px;
    box-shadow: 0 8px 20px 8px #dae5f0;
    background: #fff;
    padding: 20px;
    border-radius: 10px;
}

.button {
    width: 100%;
    position: relative;
    height: 56px;
    margin-top: 35px;
}

.button-noLogin {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;
}

.login-2u {
    background-color: #35c758;
    width: 100% !important;
    height: 40px;
    border-radius: 40px;
}

.resgiter,
.login {
    width: 100%;
    height: 40px;
    margin-bottom: 5px;
    border-radius: 40px !important;
}

/* .resgiter {
  margin-bottom: 5px;
}
.login {
  margin-left: 2%;
}
.resgiter img,
.login img {
  width: 100%;
  height: 56px;
} */
.title_wallet {
    width: 100%;
    text-align: left;
    color: #12172e;
    margin-bottom: 20px;
}

.top_main {
    padding-right: 5px;
}

/* .top_main img {
  width: 20px;
  height: 20px;
} */
.top_main span {
    color: 828590;
}

.zhuce-btn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 40px;
    text-align: center;
    color: #fff;
}

.bg-blue {
    background-color: #2BB0E9;
}

.bg-blue2 {
    background-color: #2BB0E9;
}

.intro {
    background-color: #fff;
    /* position: absolute;
  top: 160px; */
    width: calc(100% - 20px);
    overflow: hidden;
    z-index: 1;
    margin: 5px 5px 5px 10px;
    border-radius: 16px;
    min-height: 100px;
    box-shadow: 2px 2px 2px #dcdcdc;
    background-image: url("../../assets/img/index/bg_intro.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.intro2 {
    background-color: #fff;
    /* position: absolute;
  top: 160px; */
    width: calc(100% - 20px);
    overflow: hidden;
    z-index: 1;
    margin: 5px 5px 5px 10px;
    border-radius: 16px;
    min-height: 100px;
    box-shadow: 2px 2px 2px #dcdcdc;
    background-image: url("../../assets/img/index/bg_intro2.png") !important;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.intro_title {
    margin: 10px 20px;
    width: 300px;
    height: 20px;
}

.intro_desc {
    margin: 5px 20px;
    width: 280px;
    height: 20px;
}
@keyframes donghua {
		0% {
			transform: scale(0.60);
			/* 注意rgba中的a的设置 */
			box-shadow: 0 0 0 0 rgba(204, 73, 152, 80%);
			border-radius: 6px;
		}

		60% {
			transform: scale(1);
			box-shadow: 0 0 0 36px rgba(204, 73, 152, 0%);
			border-radius: 6px;
		}

		100% {
			transform: scale(0.60);
			box-shadow: 0 0 0 0 rgba(204, 73, 152, 0%);
			border-radius: 6px;
		}
	}
.greenx{
	position: absolute;
	right: 0px;
	top: 6px;
	font-size: 32px;
	font-weight:bold;
	color: #05a347;
	animation: donghua 2.4s infinite;
	display: inline-block;
}
.greenx2{
	position: absolute;
	right: 0px;
	top: 16px;
	font-size: 24px;
	font-weight:bold;
	color: #05a347;
}
.intro2 {
    /* position: absolute;
  top: 160px; */
    display: flex;
    width: calc(100% - 20px);
    z-index: 1;
    margin: 10px;
    border-radius: 16px;
    height: 100px;
    box-shadow: 0px 16px 24px #DAE5F0;

    align-items: center;
    justify-content: space-between;
    background-color: #EA0063;
    background-image: url('~@/assets/img/bg-stars.png');
    background-position: 0px 0px;
    background-repeat: repeat-x;
    animation: mymove 5s ease infinite;
}

@-webkit-keyframes mymove {
    0% {
        background-position: -150% 250%;
    }

    100% {
        background-position: 75% -250%;
    }
}

@keyframes mymove {
    0% {
        background-position: -150% 250%;
    }

    100% {
        background-position: 75% -250%;
    }

}

.intro_title2 {
    color: white;
    font-size: 1.375rem;
    text-shadow: 0 0 10px #EA0063;
}

.intro-content2 {
    padding: 26px 24px;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.intro_desc2 {

    color: #828590;
    font-size: 0.75rem;
    font-weight: bold;
    margin-top: 6px;
}

.intro-label2 {
    position: absolute;
    top: -25%;
    left: 50%;
    transform: translateX(-50%);
}

.intro-buy-now2 {
    display: flex;
    font-weight: bold;
    background-color: white;
    color: #2BB0E9;
    border-radius: 12px;
    justify-content: center;
    align-items: center;
    min-width: 64px;
    height: 42px;
    border-radius: 21px;
    text-transform: capitalize;
    margin-left: auto;
}


.buy_sto {
    position: relative;
    text-decoration: underline;
    top: -30px;
    right: -30px;
}



.hd-left-top {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 75px;
}

.cata-wx-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 75px;
    overflow: hidden;
}

.hd-left-top-wallets {
    display: flex;
    width: 25px;
    height: 25px;
}

.wallet-img {
    display: flex;
    width: 25px;
    height: 25px;
}

.scanner {
    display: flex;
    width: 25px;
    height: 25px;
    justify-content: center;
    align-items: center;
}

.scanner .scanner-mark {
    width: 25px;
    height: 25px;
}
</style>
